import { createSelector } from "@reduxjs/toolkit";

const getConfigurationStore = (state) => state.configuration;

export const getConfig = createSelector(getConfigurationStore, (configuration) => configuration.data);

export const fetchConfigEnded = createSelector(getConfigurationStore, (configuration) => configuration.fetchEnded);
